module.exports = __webpack_public_path__ + "static/media/mdm3.ca9a87dc.png";